const actions = {
  // Exchange Dashboard
  EXCHANGE_DASHBOARD_DATA_BEGIN: "EXCHANGE_DASHBOARD_DATA_BEGIN",
  EXCHANGE_DASHBOARD_DATA_SUCCESS: "EXCHANGE_DASHBOARD_DATA_SUCCESS",
  EXCHANGE_DASHBOARD_DATA_ERR: "EXCHANGE_DASHBOARD_DATA_ERR",

  // Approval List
  APPROVAL_LIST_BEGIN: "APPROVAL_LIST_BEGIN",
  APPROVAL_LIST_SUCCESS: "APPROVAL_LIST_SUCCESS",
  APPROVAL_LIST_ERR: "APPROVAL_LIST_ERR",
  APPROVAL_LIST_RESET: "APPROVAL_LIST_RESET",

  // Approval Details
  APPROVAL_DETAILS_BEGIN: "APPROVAL_DETAILS_BEGIN",
  APPROVAL_DETAILS_SUCCESS: "APPROVAL_DETAILS_SUCCESS",
  APPROVAL_DETAILS_ERR: "APPROVAL_DETAILS_ERR",
  APPROVAL_DETAILS_RESET: "APPROVAL_DETAILS_RESET",

  // Update Approval Details
  UPDATE_APPROVAL_STATUS_BEGIN: "UPDATE_APPROVAL_STATUS_BEGIN",
  UPDATE_APPROVAL_STATUS_SUCCESS: "UPDATE_APPROVAL_STATUS_SUCCESS",
  UPDATE_APPROVAL_STATUS_ERR: "UPDATE_APPROVAL_STATUS_ERR",
  UPDATE_APPROVAL_STATUS_RESET: "UPDATE_APPROVAL_STATUS_RESET",

  getExchangeDashboardDataBegin: () => ({
    type: actions.EXCHANGE_DASHBOARD_DATA_BEGIN,
  }),
  getExchangeDashboardDataSuccess: (data) => ({
    type: actions.EXCHANGE_DASHBOARD_DATA_SUCCESS,
    data,
  }),
  getExchangeDashboardDataErr: (err) => ({
    type: actions.EXCHANGE_DASHBOARD_DATA_ERR,
    err,
  }),

  getApprovalListBegin: () => ({
    type: actions.APPROVAL_LIST_BEGIN,
  }),
  getApprovalListSuccess: (data) => ({
    type: actions.APPROVAL_LIST_SUCCESS,
    data,
  }),
  getApprovalListErr: (err) => ({
    type: actions.APPROVAL_LIST_ERR,
    err,
  }),
  getApprovalListReset: () => ({
    type: actions.APPROVAL_LIST_RESET,
  }),

  // Approval Details
  getApprovalDetailsBegin: () => ({
    type: actions.APPROVAL_DETAILS_BEGIN,
  }),
  getApprovalDetailsSuccess: (data) => ({
    type: actions.APPROVAL_DETAILS_SUCCESS,
    data,
  }),
  getApprovalDetailsErr: (err) => ({
    type: actions.APPROVAL_DETAILS_ERR,
    err,
  }),
  getApprovalDetailsReset: () => ({
    type: actions.APPROVAL_DETAILS_RESET,
  }),

  updateApprovalStatusBegin: () => ({
    type: actions.UPDATE_APPROVAL_STATUS_BEGIN,
  }),

  updateApprovalStatusSuccess: (data) => ({
    type: actions.UPDATE_APPROVAL_STATUS_SUCCESS,
    data,
  }),

  updateApprovalStatusErr: (err) => ({
    type: actions.UPDATE_APPROVAL_STATUS_ERR,
    err,
  }),

  updateApprovalStatusReset: () => ({
    type: actions.UPDATE_APPROVAL_STATUS_RESET,
  }),
};

export default actions;
